import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import { motion } from 'framer-motion';
import { CountUp } from '../../components/CountUp';
import { standardVariants, containerVariants } from '../../utils/useAnimations';

const { Title, Paragraph } = Typography;

interface StatData {
  value: string;
  description: string;
}

const statsData: StatData[] = [
  {
    value: "18 millions",
    description: "<b>de personnes</b> de plus de 5 ans <b>vivent avec un handicap en France</b>"
  },
  {
    value: "5%",
    description: "des <b>enfants et adolescents</b> sont diagnostiqués avec un trouble du neuro-développement."
  },
  {
    value: "9%",
    description: "<b>des sites contrôlés</b> déclarent être <b>partiellement conformes au RGAA</b>, 0,37% totalement conformes"
  }
];

export const Stats: React.FC = () => (
  <section className="bg-primary-600 p-20">
    <div className="max-w-[1440px] mx-auto px-20">
      <motion.div
        variants={standardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <Title level={2} className="!text-4xl !font-bold !text-center !mb-12 !text-neutral-white">
          Pourquoi l'accessibilité numérique est importante ?
        </Title>
      </motion.div>
      
      <div className="max-w-[1063px] mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          <Row gutter={[30, 30]}>
            {statsData.map((stat, index) => (
              <Col md={8} key={index} className="flex">
                <motion.div variants={standardVariants}>
                  <Card className="text-center h-full bg-conic-soft bg-neutral-white border-none gradient-border-1 gradient-border-conic-vibrant">
                    <Title level={3} className="!text-3xl !font-bold !mb-2">
                      <CountUp 
                        value={stat.value}
                        duration={2.5}
                        className="inline-block"
                      />
                    </Title>
                    <Paragraph className="!text-base !mb-0">
                      <span dangerouslySetInnerHTML={{ __html: stat.description }} />
                    </Paragraph>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </div>
    </div>
  </section>
);